import * as React from "react";
const SvgDossierNew = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 16, viewBox: "0 0 20 16", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icon", transform: "translate(-2,-4.5)" }, /* @__PURE__ */ React.createElement("path", { id: "icon", d: "m 9.17,6.5 2,2 H 20 v 10 H 4 V 6.5 Z M 10,4.5 H 4 c -1.1,0 -1.99,0.9 -1.99,2 L 2,18.5 c 0,1.1 0.9,2 2,2 h 16 c 1.1,0 2,-0.9 2,-2 v -10 c 0,-1.1 -0.9,-2 -2,-2 h -8 z" })));
export default SvgDossierNew;
